import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { CommandStyleProvider } from "@/contexts/CommandStyleContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { useAuth } from "@/contexts/AuthContext";

// Running inside the Tauri desktop widget? Land straight on the Command view.
const isTauri =
  typeof window !== "undefined" &&
  ("__TAURI_INTERNALS__" in window || "__TAURI__" in window);

function RootRoute() {
  const { user, loading } = useAuth();
  if (isTauri) return <Navigate to="/command" replace />;
  if (loading) return <div className="flex items-center justify-center h-screen bg-background text-foreground">Loading...</div>;
  return user ? <Dashboard /> : <Landing />;
}
import { ThemeProvider } from "@/contexts/ThemeContext";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import CalendarPage from "@/pages/Calendar";
import Messages from "@/pages/Messages";
import Settings from "@/pages/Settings";
import Sessions from "@/pages/Sessions";
import Transcripts from "@/pages/Transcripts";
import Command from "@/pages/Command";
import NotFound from "@/pages/NotFound";
import { XpPopupLayer } from "@/components/ui/xp-popup";
import { FocusProvider } from "@/contexts/FocusContext";
import { FocusScreen } from "@/components/focus/FocusScreen";

const queryClient = new QueryClient();

export default function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <CommandStyleProvider>
            <FocusProvider>
            <FocusScreen />
            <Routes>
              <Route path="/welcome" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route
                path="/week"
                element={
                  <ProtectedRoute>
                    <CalendarPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects/:slug"
                element={
                  <ProtectedRoute>
                    <ProjectDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  <ProtectedRoute>
                    <Projects />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/messages"
                element={
                  <ProtectedRoute>
                    <Messages />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sessions"
                element={
                  <ProtectedRoute>
                    <Sessions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transcripts"
                element={
                  <ProtectedRoute>
                    <Transcripts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/command"
                element={
                  <ProtectedRoute>
                    <Command />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<RootRoute />} />
              {/* ticket 56eac710 #11: explicit 404 instead of silently
                  rendering the dashboard for every unknown path. */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <XpPopupLayer />
            <Toaster />
            </FocusProvider>
            </CommandStyleProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
